import React, { useState } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import SendIcon from '@mui/icons-material/Send';
import Input from '@mui/material/Input';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@material-ui/core/IconButton';
import API from '../../../../create/api';
import { useStore } from 'react-redux';

export default function CommentBox(props: { parcel_id: number; reload_parcel: () => Promise<void> }) {
  const store = useStore();
  const [get_comment, set_comment]: any = useState('');

  async function submitcomment() {
    if (get_comment && get_comment?.trim()?.length > 0) {
      await API.create(`${process.env.REACT_APP_API_SERVER}/parcel-logs`, {
        details: get_comment,
        type: 'comment',
        parcel: props.parcel_id,
        parcel_id: props.parcel_id,
        user: store.getState()?.auth?.user?.id,
        user_id: store.getState()?.auth?.user?.id,
      }).then((response) => {
        set_comment('');

        setTimeout(() => {
          props.reload_parcel();
        }, 1000);
      });
    }
  }

  return (
    <Box>
      <Paper elevation={1} sx={{ p: 2 }}>
        <FormControl fullWidth variant="standard">
          <InputLabel htmlFor="standard-adornment-amount">Comment</InputLabel>
          <Input
            value={get_comment}
            onChange={(e) => {
              set_comment(e.target.value ?? '');
            }}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                submitcomment();
              }
            }}
            id="outlined-basic"
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" onClick={submitcomment}>
                  <SendIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Paper>
    </Box>
  );
}
